<div id="page-title">
  <div id="page-content" class="inicio" id="transacoes">
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1">
        <div class="row">
          <div class="col-sm-6">
            <div id="input-tag" class="input textarea caixa-pesquisa">
              <div><input class="input-searchbox" type="text" placeholder="Pesquisar" (keyup)="filter($event)"></div>
            </div>
          </div>
        </div>
        <div *ngIf="!success && !error" class="container-loading">
          <div class="btn btn-registrar loading"></div>
        </div>
        <table id="master-detail-table-clients" style="width: 100%"></table>
      </div>
    </div>
  </div>
</div>
